"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.biasNumericRange = exports.bigIntLogLike = exports.integerLogLike = void 0;

function integerLogLike(v) {
  return Math.floor(Math.log(v) / Math.log(2));
}

exports.integerLogLike = integerLogLike;

function bigIntLogLike(v) {
  if (v === BigInt(0)) return BigInt(0);
  return BigInt(v.toString().length);
}

exports.bigIntLogLike = bigIntLogLike;

function biasNumericRange(min, max, logLike) {
  if (min === max) {
    return [{
      min: min,
      max: max
    }];
  }

  if (min < 0 && max > 0) {
    var logMin = logLike(-min);
    var logMax = logLike(max);
    return [{
      min: -logMin,
      max: logMax
    }, {
      min: max - logMax,
      max: max
    }, {
      min: min,
      max: min + logMin
    }];
  }

  var logGap = logLike(max - min);
  var arbCloseToMin = {
    min: min,
    max: min + logGap
  };
  var arbCloseToMax = {
    min: max - logGap,
    max: max
  };
  return min < 0 ? [arbCloseToMax, arbCloseToMin] : [arbCloseToMin, arbCloseToMax];
}

exports.biasNumericRange = biasNumericRange;